module.exports = __webpack_public_path__ + "static/media/pin.fbfe1568.svg";